/**
 * @Author:
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import _ from 'lodash';
import { createBEM } from 'src/util/bem';
import './sysSideList.less';
let bem = createBEM('sys-side-list');

export interface SysSideListPropsI {
    title: string;
    dataSource: { id: number; name: string }[];
    value?: number|null
}

@Component
export default class SysSideList extends Vue.Component<SysSideListPropsI> {
    @Prop({
        type: String,
    })
    title!: string;

    @Prop({
        type: Number,
    })
    value!: number|null;

    @Prop({
        type: Array,
    })
    dataSource!: { id: number; name: string }[];

    add() {
        this.$emit('add');
    }
    update(i, e) {
        e.stopPropagation()
        this.$emit('update', i);
    }
    delete(i, e) {
        e.stopPropagation()
        this.$emit('delete', i);
    }
    select(i) {
        this.$emit('input', i.id);
        
    }
    render(h) {
        return (
            <div class={bem()}>
                <div class={bem('title')}>
                    {this.title}
                    <div class={bem('add')} on-click={this.add.bind(this)}>
                        新增
                    </div>
                </div>
                <div class={bem('content')}>
                    {
                        this.dataSource.map(i=> <div class={bem('list-item', {active: i.id === this.value})} on-click={this.select.bind(this, i )}>
                            <div>{i.name}</div>
                            <span on-click={this.update.bind(this, i)}>修改</span>
                            <span on-click={this.delete.bind(this, i)}>删除</span>
                        </div>)
                    }
                </div>
            </div>
        );
    }
}
